<template>
  <v-dialog v-model="dialog" max-width="550" persistent>
    <v-card class="modal-card" elevation="10">
      <div class="modal-header">
        <v-icon class="header-icon" size="48" color="white"> mdi-school-outline </v-icon>
        <v-card-title class="headline white--text pa-0 mt-3">
          Matrículas Anteriores Encontradas
        </v-card-title>
      </div>
      <v-card-text class="pt-6 pb-4">
        <div v-if="matriculasAnterioresList.length > 0">
          <v-alert
            type="warning"
            colored-border
            border="left"
            elevation="2"
            class="mb-4 custom-alert"
          >
            <div class="d-flex align-center">
              <div>
                <strong class="d-block mb-1">Atenção!</strong>
                <span class="body-2">
                  Detectamos {{ matriculasAnterioresList.length }}
                  {{
                    matriculasAnterioresList.length === 1
                      ? "matrícula anterior"
                      : "matrículas anteriores"
                  }}
                  na mesma turma.
                </span>
              </div>
            </div>
          </v-alert>

          <div class="matriculas-list mb-4">
            <div class="list-title mb-2">
              <v-icon small color="#FB9716" class="mr-2">mdi-format-list-bulleted</v-icon>
              <span class="font-weight-bold">Matrículas Encontradas:</span>
            </div>
            <v-chip
              v-for="(mat, index) in matriculasAnterioresList"
              :key="index"
              class="ma-1"
              color="#FB9716"
              outlined
              small
            >
              <v-icon left small>mdi-account-circle</v-icon>
              ID: {{ mat.id }}
              <v-icon center small>mdi-chevron-right</v-icon>
              Turma: {{ mat.turma.descricao }}
            </v-chip>
          </div>

          <v-card class="instruction-card" outlined>
            <v-card-text class="pa-3">
              <div class="d-flex align-start">
                <v-icon color="#4caf50" class="mr-3 mt-1"> mdi-lightbulb-on-outline </v-icon>
                <div>
                  <p class="mb-2 font-weight-medium">Como proceder:</p>
                  <p class="mb-0 body-2 grey--text text--darken-2">
                    Caso queira, você pode importar as notas e faltas existentes na matrícula
                    anterior habilitando a opção
                    <strong class="import-text">"Importar Notas e Faltas?"</strong>
                    no formulário de matrícula.
                  </p>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </div>
      </v-card-text>

      <v-divider></v-divider>
      <v-card-actions class="pa-4">
        <v-spacer></v-spacer>
        <v-btn color="#FB9716" depressed dark @click="fecharModal" class="px-6 action-button">
          <v-icon left>mdi-check</v-icon>
          Entendi
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "EModalMatriculasAnteriores",
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    matriculasAnterioresList: {
      type: Array,
      required: true,
    },
  },
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    fecharModal() {
      this.dialog = false;
    },
  },
};
</script>

<style scoped>
.modal-card {
  border-radius: 12px !important;
  overflow: hidden;
}

.modal-header {
  background: #fb9716;
  padding: 24px;
  text-align: center;
}

.headline {
  display: flex;
  justify-content: center;
  text-align: center;
  text-align: center !important;
  font-size: 20px !important;
  font-weight: 600 !important;
  line-height: 1.3 !important;
}

.custom-alert {
  border-left-color: #fb9716 !important;
}

.instruction-card {
  background-color: #f5f5f5;
  border-radius: 8px;
  transition: all 0.3s ease;
  border-color: #e0e0e0;
}

.instruction-card:hover {
  background-color: #eeeeee;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.matriculas-list {
  padding: 12px;
  background-color: #fafafa;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
}

.list-title {
  display: flex;
  align-items: center;
  color: #424242;
}

.v-chip {
  transition: transform 0.2s ease;
}

.v-chip:hover {
  transform: scale(1.05);
}

.import-text {
  color: #fb9716;
}

.action-button {
  font-weight: 600;
  letter-spacing: 0.5px;
  transition: all 0.3s ease;
}

.action-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(251, 151, 22, 0.4);
}
</style>
